import { createTocNodeSpec } from "./nodes";
export function tocNodeSpec() {
    return {
        toc: createTocNodeSpec(),
    };
}
